import { applyMiddleware, combineReducers, createStore, compose } from 'redux';
import { thunk }  from 'redux-thunk';

import {
    pageIsLoading,
    pageError,
    pageHasErrored,
    pageCurrentStep,
} from './reducers';

import {
    startPageData,
    startPageAnimalPossessionQuoteData
} from '../Pages/SignedInStartPage/State/reducers';


import {
    preregistrationPageData
} from '../Pages/InsurancePreregistrationPage/State/reducers';

import {
    healthDeclarationPageData,
    healthDeclarationFormInputs,
    healthDeclarationRepeatedInputs,
    healthDeclarationStatus,
    healthDeclarationSavedResult
} from '../Pages/InsuranceHealthDeclarationPage/State/reducers';

import {
    pensionGuidancePageData,
    pensionGuidanceRepeatedInputs,
    pensionGuidanceFormInputs,
    pensionGuidanceStatus,
    pensionGuidanceSavedResult
} from '../Pages/PensionGuidanceQuestionPage/State/reducers';

import {
    profilePageData
} from '../Pages/ProfilePage/State/reducers';

import {
    extendStudentInsuranceTeaserData
} from '../Features/ExtendStudentInsuranceTeaser/State/reducers';

import {
    coInsuredFormData
} from '../Features/CoInsuredFormBlock/State/reducers';

import {
    achievementsData,
    newAchievementsData
} from '../Pages/Achievements/State/reducers';


import {
    travelCertPageData
} from '../Pages/TravelCertificatePage/State/reducers';


import {
    announcerData
} from '../Features/Announcers/State/reducers';

import {
    wizardData
} from '../Features/CustomerKnowledgeWizardBlock/State/reducers';

import {
    pensionWizard,
    pensionWizardFlow,
    pensionWizardView,
    pensionWizardModal,
    pensionWizardProgress
} from '../Features/PensionInsuranceWizardBlock/State/reducers';


import {
    possessionsData,
    metaData
} from '../Features/SignedInPossessionsListing/State/reducers';

import {
    faqData
} from '../Features/CategorizedFAQQuestionBlock/State/reducers';

import customerInfoReducers from '../Pages/CustomerInfoPage/Reducers';

import { preregistrationSummary } from '../Features/PurchasesStatusTeaser/State/reducers';

export function configureStore(initialState) {
    // enable redux devtools if debug global is set
    const composeEnhancers =
        window._bazDebug && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
            ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                serialize: {
                    options: true
                }
            })
            : compose;

    const rootReducer = combineReducers({
        pageIsLoading,
        pageError,
        pageHasErrored,
        pageCurrentStep,

        startPageData,
        startPageAnimalPossessionQuoteData,


        healthDeclarationPageData,
        healthDeclarationFormInputs,
        healthDeclarationRepeatedInputs,
        healthDeclarationStatus,
        healthDeclarationSavedResult,

        pensionGuidancePageData,
        pensionGuidanceFormInputs,
        pensionGuidanceRepeatedInputs,
        pensionGuidanceStatus,
        pensionGuidanceSavedResult,

        preregistrationPageData,

        profilePageData,

        extendStudentInsuranceTeaserData,

        coInsuredFormData,

        announcerData,

        wizardData,
        pensionWizard,
        pensionWizardFlow,
        pensionWizardView,
        pensionWizardModal,
        pensionWizardProgress,

        possessionsData,
        metaData,

        faqData,

        achievementsData,
        newAchievementsData,

        travelCertPageData,

        customerInfoPageCustomerInfo: customerInfoReducers.customerInfo,
        customerInfoPageCoInsuredInfo: customerInfoReducers.coInsuredInfo,
        customerInfoPageCustomerAnimals: customerInfoReducers.customerAnimals,
        customerInfoPageCustomerChildren: customerInfoReducers.customerChildren,

        preregistrationSummary,

    });

    return createStore(
        rootReducer,
        initialState,
        composeEnhancers(applyMiddleware(thunk))
    );
};
